import { useEffect } from 'react';
import useConfirmDialog from './ui/useConfirmDialog';
import { setDocumentWarningPrompt } from '../services/documentWarningPrompt';

/** The dialog behind documentWarningPrompt.js: what's wrong, what prints, and the adviser's call. */
export default function DocumentWarningPrompt() {
  const [confirm, dialog] = useConfirmDialog();

  useEffect(() => setDocumentWarningPrompt((warnings) => confirm({
    title: 'Check this document',
    description: warnings.map((w) => [w.message, w.ifProceeded].filter(Boolean).join('\n')).join('\n\n'),
    confirmLabel: 'Proceed anyway',
    cancelLabel: 'Go back',
  })), [confirm]);

  return dialog;
}
